export const decodeStartParamToUrl = (startParam?: string): URL | null => {
  if (!startParam) {
    return null;
  }

  try {
    const decodedParam = atob(startParam);

    return new URL(decodedParam, window.location.origin);
  } catch {
    return null;
  }
};
